import React from 'react'
import classes from './StoreToggleList.module.sass'
import { Toggle } from '../../../../../common/components/toggle/Toggle'
import { StoreInterface } from '../../../../../common/types/interfaces'

interface Props {
  stores: StoreInterface[]
  item_stops: { storeId: number; isStopped: boolean }[]
  onToggle: (storeId: number, isStopped: boolean) => void
  disabled?: boolean
}

export const StoreToggleList = ({ stores, item_stops, onToggle, disabled = false }: Props) => {
  const getIsAvailable = (storeId: number) => {
    const isStopped = item_stops.find((s) => s.storeId === storeId)?.isStopped ?? false
    return !isStopped
  }

  return (
    <div className={classes.container}>
      <div className={classes.title}>Доступность в точках</div>
      <div className={classes.list}>
        {stores.map((store) => {
          const storeId = store.id
          if (!storeId) return null

          const isAvailable = getIsAvailable(storeId)
          const toggleId = `toggle-store-${storeId}`

          return (
            <div key={storeId} className={classes.row}>
              <div className={classes.toggleContainer}>
                <Toggle
                  id={toggleId}
                  checked={isAvailable}
                  disabled={disabled}
                  onChange={() => onToggle(storeId, !isAvailable)}
                />
                <span className={classes.label}>{store.name}</span>
              </div>
              
            </div>
          )
        })}
      </div>
    </div>
  )
}
